import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("应用规则")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, computed, onBeforeMount, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import store from '@/store/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { 
  'POST/checkin_user_rules/list': fetchList,
  // 规则list
  'GET/checkin_punch_rules': ruleListApi,
  // 员工列表(不分页,下拉框)
  'GET/users/list': userListApi,
  // 一键生成用户对应打卡规则
  'POST/checkin_user_rules/all': checkin_user_rulesAllApi,
  // 未设置员工名单
  'GET/checkin_user_rules': checkin_user_rulesApi,
 } = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
fetchData()

let userRows: any = ref([])
let fullUserList: any = ref([])
let ruleList: any = ref([])
onBeforeMount(() => {
  ruleListApi().then((rep: any) => {
    ruleList.value = rep
  })

  userListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.label = `${_user.realName}(${_user.alias})`
      return _user
    })
  })

  
})

const searchConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'key',
    props: { maxlength: 20, placeholder: '请输入姓名'},
  },
  {
    type: 'SELECT',
    label: '设置类型',
    value: '',
    upKey: 'unset',
    options: [
      { label: '未设置人员', id: '未设置人员' },
    ],
    props: {clearable: true, placeholder: '请选择设置类型',},
    seleProps: { }
  },
  {
    type: 'SELECT',
    label: '规则',
    value: '',
    upKey: 'ruleId',
    options: ruleList,
    props: { clearable: true, placeholder: '请选择规则', multiple: true, 'collapse-tags': true },
    seleProps: { label: 'name', valueName: 'id' },
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: store.getters.sysOrganizations,
    props: {placeholder: '请选择团队', clearable: true},
    seleProps: {label: 'name', valueName: 'id'}
  },
  {
    type: 'SELECT',
    selectType: 'GROUP',
    label: '公司',
    value: '',
    upKey: 'companyId',
    options: store.getters.sysCompany,
    seleProps: { label: 'name', valueName: 'id', },
    props: {clearable: true, placeholder: '请选择公司'}
  },
])

// 一键生成用户对应打卡规则
const isShowApply = ref(false)
const applyObj = reactive({
  ruleId: '', expiredDate: '', expiredChangedRuleId: ''
})
const ruleHandle = () => {
  if(userRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  applyObj.ruleId = ''
  applyObj.expiredDate = ''
  applyObj.expiredChangedRuleId = ''
  isShowApply.value = true
}
const submitRule = () => {
  checkin_user_rulesAllApi({
    userIds: userRows.value.map((e: any) => e.userId),
    ...applyObj,
  }).then(() => {
    ElMessage.success('应用成功')
    isShowApply.value = false
    fetchData(MI_params)
  })
}

// 未设置员工名单
const unsetFg = ref<boolean>(false)
const { 
  MI_tableData: unDate, fetchData: unFetchDate,  MI_identify: unIdentify
} = new tbMix(checkin_user_rulesApi)
const unsetHandle = () => {
  unsetFg.value = true
  unFetchDate()
}
const unTableDate = computed(() => {
  return unDate.value.map((e) => {
    return {name: e}
  })
})


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "用户规则" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
            title: true,
            searchConfig: searchConfig.value
          }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (ruleHandle())),
      disabled: _unref(MI_identify),
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      class: "mt-10",
      style: {"width":"1100px"},
      "max-height": _unref(MI_height) - 75 + 'px',
      data: _unref(MI_tableData),
      onSelectionChange: _cache[1] || (_cache[1] = (rows) => { _isRef(userRows) //@ts-ignore
 ? userRows.value = rows : userRows = rows })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          label: "员工",
          prop: "realName"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.realName + '(' + row.alias + ')'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "规则",
          prop: "name",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "规则过期时间",
          prop: "expiredDate",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "过期后规则",
          prop: "expiredChangedRuleName",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "orgName"
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["max-height", "data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      style: {"float":"none"},
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [10, 30, 50, 100],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "用户应用规则",
      width: "580px",
      modelValue: isShowApply.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isShowApply).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (isShowApply.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (submitRule())),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(applyObj),
          "label-position": "top",
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "规则:",
              prop: "ruleId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(applyObj).ruleId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(applyObj).ruleId) = $event)),
                  placeholder: "请选择规则",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ruleList), (rule) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: rule.id,
                        label: rule.name,
                        value: rule.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "过期时间:",
              prop: "expiredDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(applyObj).expiredDate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(applyObj).expiredDate) = $event)),
                  placeholder: "请选择过期时间",
                  "value-format": "YYYY-MM-DD",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "过期后规则:",
              prop: "expiredChangedRuleId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(applyObj).expiredChangedRuleId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(applyObj).expiredChangedRuleId) = $event)),
                  placeholder: "请选择过期后规则",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ruleList), (rule) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: rule.id,
                        label: rule.name,
                        value: rule.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: unsetFg.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((unsetFg).value = $event)),
      title: "未设置员工名单"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _unref(unTableDate),
          border: "",
          "max-height": "550"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "员工",
              prop: "name"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(unIdentify)]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})